import React from "react";
import LegalLayout from "../../components/LegalLayout";
import { SUPPORT_EMAIL } from "../../lib/content";

export default function AccountDeletion() {
  return (
    <LegalLayout
      title="Account & Data Deletion"
      seoPath="/account-deletion"
      intro={`You can ask us to delete your Jollof Fit Kingdom account and the personal data associated with it at any time. This page explains how to make a request and what to expect.`}
      sections={[
        {
          heading: "How to Request Deletion",
          body: [
            `To delete your Jollof Fit Kingdom account and associated personal data, email us at ${SUPPORT_EMAIL} from the email address linked to your account, with the subject line "Account Deletion Request".`,
            "Please do not use the partnerships email for deletion requests — account and data deletion is handled only through our general support email above.",
          ],
        },
        {
          heading: "What Gets Deleted",
          body: ["When your request is processed, we remove or anonymize the personal data associated with your account, which may include:"],
          list: [
            "Your account and profile information.",
            "Your health, fitness, workout and nutrition data.",
            "Body composition and connected-device data stored with your account.",
            "Progress photos you added.",
            "Your Kingdom Score history and insights.",
          ],
        },
        {
          heading: "Subscriptions",
          body: ["Deleting your account does not automatically cancel a paid subscription purchased through an app store. To stop billing, also cancel your subscription through your Google Play or Apple subscription settings."],
        },
        {
          heading: "Processing & Legal Retention",
          body: [
            "We handle deletion requests in line with applicable law. We action valid requests within a reasonable timeframe.",
            "Some information may be retained where we are legally required to keep it, or for legitimate purposes such as fraud prevention, security or resolving disputes. In those cases we retain only what is necessary and for no longer than required.",
          ],
        },
        {
          heading: "Confirmation",
          body: ["Once your request is completed, we will confirm by email. If you have any questions about the process, contact us using the details below."],
        },
      ]}
    />
  );
}
